import React from "react"
import autobind from "class-autobind"
import { TextField, Toggle, Dialog, FlatButton, Paper, FontIcon } from "material-ui"
import UserProfileStore from "../../stores/UserProfileStore"
import AuthenticationStore from "../../stores/AuthenticationStore"
import CircularProgress from "material-ui/CircularProgress"
import ImageLoader from "../../components/misc/ImageLoader"
import strings from "../../localization/strings"
import * as userActions from "../../actions/UserActions"
import * as loginActions from "../../actions/LoginActions"
import * as utils from "../../helpers/utils"
import * as api from "../../api"
import AppStateStore from "../../stores/AppStateStore"
import PasswordField from "../../components/common/PasswordField"

interface IProps {

}
interface IState {
    open: boolean
    userId: string
    firstName: string
    lastName: string
    originalEmail: string
    email: string
    firstNameErrorText: string
    lastNameErrorText: string
    emailErrorText: string
    showProgress: boolean
    profileImageS3Url: string
    profileImageID: string
    password: string
    passwordVerified: boolean
    passwordConfirmationError: string
    passwordConfirmation: string
    passwordChanged: boolean
    emailNotifications: boolean
    granddCentralNotifications: boolean
}

export default class UserProfileDialog extends React.Component<IProps, IState> {
    private saveClicked
    private FirstNameInput
    constructor(props: IProps) {
        super(props)
        this.state = {
            open: UserProfileStore.getEditDialogOpen(),
            userId: "",
            firstName: "",
            lastName: "",
            originalEmail: "",
            email: "",
            firstNameErrorText: "",
            lastNameErrorText: "",
            emailErrorText: "",
            showProgress: false,
            profileImageS3Url: null,
            profileImageID: null,
            password: "",
            passwordVerified: true,
            passwordConfirmationError: "",
            passwordConfirmation: "",
            passwordChanged: false,
            emailNotifications: false,
            granddCentralNotifications: false,
        }
        autobind(this)
    }

    componentDidMount() {
        UserProfileStore.on("change", this.changeEvent)
        UserProfileStore.on("opened", this.openEvent)
    }

    componentWillUnmount() {
        UserProfileStore.removeListener("change", this.changeEvent)
        UserProfileStore.removeListener("opened", this.openEvent)
    }

    handleFirstNameChange(e) {
        this.setState({ firstName: e.target.value },
            () => this.saveClicked &&
                this.validateForm()
        )
    }

    handleLastNameChange(event) {
        this.setState({ lastName: event.target.value },
            () => this.saveClicked &&
                this.validateForm()
        )
    }

    handleEmailNameChange(event) {
        this.setState({ email: event.target.value },
            () => this.saveClicked &&
                this.validateForm()
        )
    }

    handlePasswordConfirmationChange(event) {
        this.setState({
            passwordConfirmation: event.target.value,
            passwordChanged: true
        }, () =>
            this.saveClicked &&
            this.validateForm()
        )
    }

    detectEnter(event) {
        event.keyCode === 13 &&
            this.handleRequestSave()
    }

    openEvent() {
        this.setState({ showProgress: true })
        userActions.loadUser(AuthenticationStore.getLoggedInUser().Id).then((response) => {
            this.saveClicked = false
            this.setState({
                open: UserProfileStore.getEditDialogOpen(),
                userId: response.data.Id,
                firstName: response.data.FirstName,
                lastName: response.data.LastName,
                email: response.data.Email,
                originalEmail: response.data.Email,
                profileImageS3Url: response.data.ProfileImageS3Url,
                profileImageID: response.data.ProfileImageID,
                showProgress: false,
                firstNameErrorText: "",
                lastNameErrorText: "",
                emailErrorText: "",
                passwordConfirmationError: "",
                passwordVerified: true,
                password: "",
                passwordConfirmation: "",
                emailNotifications: response.data.NotificationSettings && response.data.NotificationSettings.IntercomNotificationSettings && response.data.NotificationSettings.IntercomNotificationSettings.SendEmailNotification ? true : false,
                granddCentralNotifications: response.data.NotificationSettings && response.data.NotificationSettings.IntercomNotificationSettings && response.data.NotificationSettings.IntercomNotificationSettings.SendAppNotification ? true : false,
            },
                () => {
                    setTimeout(() => {
                        this.FirstNameInput.focus()
                        this.FirstNameInput.select()
                    }, 100)
                }
            )
        })
    }

    changeEvent() {
        this.setState({ open: UserProfileStore.getEditDialogOpen() })
    }

    validateForm() {
        let returnVal = true
        if (this.state.firstName.length === 0) {
            this.setState({ firstNameErrorText: strings.First_Name_cannot_be_empty })
            returnVal = false
        } else {
            this.setState({ firstNameErrorText: "" })
        }

        if (this.state.lastName.length === 0) {
            this.setState({ lastNameErrorText: strings.Last_Name_cannot_be_empty })
            returnVal = false
        } else {
            this.setState({ lastNameErrorText: "" })
        }

        if (!utils.validateEmail(this.state.email)) {
            this.setState({ emailErrorText: strings.Valid_email_required })
            returnVal = false
        } else {
            this.setState({ emailErrorText: "" })
        }

        if (this.state.password !== this.state.passwordConfirmation) {
            this.setState({ passwordConfirmationError: strings.Passwords_must_match })
            returnVal = false
        } else {
            this.setState({ passwordConfirmationError: "" })
        }

        if (this.state.password && !this.state.passwordVerified) {
            returnVal = false
        }

        if (this.state.originalEmail === this.state.email) {
            return new Promise((fulfill, reject) => fulfill(returnVal))
        } else {
            if (!this.state.email) {
                this.setState({ emailErrorText: strings.Email_cannot_be_empty })
                return new Promise((fulfill, reject) => fulfill(false))
            }
            return userActions.emailExists(this.state.email).then((result) => {
                if (result.data) {
                    this.setState({ emailErrorText: strings.Email_already_in_use })
                    returnVal = false
                }
                return returnVal
            })
        }
    }

    onChangeProfilePic() { }

    handleRequestClose() {
        userActions.closeUserProfileDialog()
    }

    async handleRequestSave() {
        this.saveClicked = true
        var validate = await this.validateForm()
        if (!validate) return

        const IntercomNotificationSettings = AuthenticationStore.getLoggedInUser().NotificationSettings && AuthenticationStore.getLoggedInUser().NotificationSettings.IntercomNotificationSettings ? AuthenticationStore.getLoggedInUser().NotificationSettings.IntercomNotificationSettings : { SendEmailNotification: null, SendAppNotification: null }
        IntercomNotificationSettings["SendEmailNotification"] = this.state.emailNotifications
        IntercomNotificationSettings["SendAppNotification"] = this.state.granddCentralNotifications
        userActions.closeUserProfileDialog()
        const userProfile = {
            FirstName: this.state.firstName,
            LastName: this.state.lastName,
            Email: this.state.email,
            PasswordUpdate: this.state.password.length > 0 ? this.state.password : null,
            UserModified: true,
            NotificationSettings: { IntercomNotificationSettings }
        }
        await api.patchUser(AuthenticationStore.getLoggedInUser().Id, userProfile)
        loginActions.getAuthData(AuthenticationStore.getLoggedInUser().Id)
    }

    render() {
        return (
            <Dialog
                actionsContainerClassName="UserProfileDialog"
                open={this.state.open}
                title={
                    <div style={{ display: "flex" }}>
                        <h2>{strings.Profile_Picture.split(" ")[0].toUpperCase()}</h2>
                        {this.state.userId !== "" &&
                            <FontIcon
                                data-intercom-target={"menu-Dashboard-UserProfileDialog-openSelfEmployeeNotesAndAudit"}
                                className="fa fa-info-circle"
                                style={{ fontSize: 20, color: "#777777", margin: "18px 10px 0px 8px", cursor: "pointer" }}
                                onTouchTap={() => AppStateStore.setNoteDrawerContent({
                                    drawerTitle: `${this.state.firstName} ${this.state.lastName}`,
                                    objectData: { ObjectId: this.state.userId },
                                    objectName: `${this.state.firstName} ${this.state.lastName}`,
                                    dataType: "user",
                                })}
                            />
                        }
                    </div>
                }
                actions={
                    <div>
                        <FlatButton label={strings.CANCEL} secondary onTouchTap={this.handleRequestClose} />
                        <FlatButton label={strings.SAVE} primary onTouchTap={this.handleRequestSave} />
                    </div>
                }
            >
                {this.state.showProgress ?
                    <div className="spinner">
                        <CircularProgress />
                    </div> :
                    <form id="UserProfileDialogBox">
                        <div className="user-profile-dialog-box">
                            <div style={{ width: "45%", float: "left" }}>
                                <div style={{ height: 60 }}>
                                    <TextField
                                        ref={(item) => this.FirstNameInput = item}
                                        floatingLabelText={strings.First_Name}
                                        value={this.state.firstName}
                                        onChange={this.handleFirstNameChange}
                                        onKeyUp={this.detectEnter}
                                        errorText={this.state.firstNameErrorText}
                                        style={{ width: "100%" }}
                                    />
                                </div>
                                <div style={{ height: 60 }}>
                                    <TextField
                                        floatingLabelText={strings.Last_Name}
                                        value={this.state.lastName}
                                        onChange={this.handleLastNameChange}
                                        onKeyUp={this.detectEnter}
                                        errorText={this.state.lastNameErrorText}
                                        style={{ width: "100%" }}
                                    />
                                </div>
                                <div style={{ height: 60 }}>
                                    <TextField
                                        floatingLabelText={strings.Email}
                                        value={this.state.email}
                                        onChange={this.handleEmailNameChange}
                                        onKeyUp={this.detectEnter}
                                        errorText={this.state.emailErrorText}
                                        style={{ width: "100%" }}
                                    />
                                </div>
                                <div>
                                    <PasswordField
                                        password={this.state.password}
                                        handleChange={(password, passwordVerified) =>
                                            this.setState({
                                                password,
                                                passwordVerified,
                                                passwordChanged: true
                                            }, () =>
                                                this.saveClicked &&
                                                this.validateForm()
                                            )
                                        }
                                        handleSave={(password, passwordVerified) =>
                                            this.setState({
                                                password,
                                                passwordVerified,
                                                passwordChanged: true
                                            }, () =>
                                                this.saveClicked &&
                                                this.validateForm()
                                            )
                                        }
                                    />
                                </div>
                                <div style={{ height: 60 }}>
                                    <TextField
                                        floatingLabelText={strings.Password_Confirmation}
                                        value={this.state.passwordConfirmation}
                                        onChange={this.handlePasswordConfirmationChange}
                                        onKeyUp={this.detectEnter}
                                        type="password"
                                        style={{ width: "100%" }}
                                        errorText={this.state.passwordConfirmationError}
                                    />
                                </div>
                            </div>
                            <div style={{ width: "45%", float: "right" }}>
                                {(() => {
                                    if (this.state.profileImageS3Url) {
                                        const url = this.state.profileImageS3Url
                                        const src = "/users/profileimage/" + this.state.profileImageID

                                        return (
                                            <div style={{ textAlign: "center" }}>
                                                <Paper
                                                    zDepth={1}
                                                    style={{
                                                        display: "inline-block"
                                                    }}
                                                >
                                                    <ImageLoader url={url} src={src} fixedHeight={250} />
                                                </Paper>
                                                {/*<RaisedButton
													label="Change Image"
													icon={<i className="fa fa-user" />}
													onClick={this.onChangeProfilePic}
													secondary={false}
												style={{marginTop:10, width:"50%", height:"40px", display:"none"}}/>*/}
                                            </div>
                                        )
                                    } else {
                                        return null
                                        /*return(
                                            <div className="user-profile-image-container">
                                                <i className="fa fa-camera" style={{fontSize:50}}/>
                                                <div style={{fontSize:20}}>Change your profile photo</div>
                                            </div>
                                        );*/
                                    }
                                })()}

                                {/* Release Notification Settings */}
                                <div style={{ marginTop: 30 }}>
                                    <h3 style={{ color: "#616161" }}>{strings.Release_Updates}</h3>
                                    <p style={{ color: "#616161" }}>{strings.Release_Update_Text}</p>
                                    <div style={{ float: "right" }}>
                                        <Toggle
                                            toggled={this.state.emailNotifications}
                                            label={strings.Email_Notifications}
                                            onToggle={(_, emailNotifications) => this.setState({ emailNotifications })}
                                            style={{ width: 250 }}
                                        />
                                        <Toggle
                                            toggled={this.state.granddCentralNotifications}
                                            label={strings.Grandd_Central_Notification}
                                            onToggle={(_, granddCentralNotifications) => this.setState({ granddCentralNotifications })}
                                            style={{ width: 250 }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style={{ clear: "both" }} />
                        </div>
                    </form>
                }
            </Dialog>
        )
    }
}
